import { z } from 'zod';

const sanitizeInput = (value: string) =>
  value
    .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '')
    .replace(/\s+/g, '')
    .trim();

const normalizePhone = (value: string) => {
  const sanitized = sanitizeInput(value);
  return sanitized.startsWith('+') ? sanitized : `+${sanitized}`;
};

export const phoneSchema = z
  .string()
  .transform(normalizePhone)
  .refine(value => /^\+\d{6,15}$/.test(value), {
    message:
      'Enter a valid phone number (6–15 digits, optionally starting with +). Example: +123456789012 or 123456789012',
  });

export const pinSchema = z
  .string()
  .transform(sanitizeInput)
  .refine(value => /^\d{7,16}#$/.test(value), {
    message:
      'Enter a valid Google Meet PIN (must be 7–16 digits ending with #). Example: 1234567#',
  });

export const validatePhone = (value?: string): string | undefined | boolean => {
  if (!value) return false;

  const result = phoneSchema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};

export const validatePin = (value?: string): string | undefined | boolean => {
  if (!value) return false;

  const result = pinSchema.safeParse(value);
  if (!result.success) {
    return result.error.issues[0].message;
  }

  return undefined;
};
